/**
 * Normalised transport error. Everything thrown out of the API layer is an
 * `ApiError`, so error boundaries and toasts only ever handle one shape.
 */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly details?: unknown;

  constructor(message: string, status: number, code: string, details?: unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
  }

  static fromResponse(response: Response, body: unknown): ApiError {
    const payload = (body ?? {}) as {
      code?: string;
      /** Goa error responses carry the code as `name`. */
      name?: string;
      message?: string;
      details?: unknown;
    };

    return new ApiError(
      payload.message ?? `Request failed with status ${response.status}`,
      response.status,
      payload.code ?? payload.name ?? 'unknown_error',
      payload.details
    );
  }
}

export const isApiError = (error: unknown): error is ApiError =>
  error instanceof ApiError;
